import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IComponentSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { IComponentProps } from './index';

export const generate = (
  props?: Partial<IComponentSchema<IComponentProps>>
): IComponentSchema<IComponentProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.VOID,
    name: props?.name || id,
    title: props?.title || 'Tag',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.Tag,
    'x-component-props': {
      text: 'Tag',
      color: 'blue',
      generateRandomColor: false,
      bordered: true,
      closable: false,
      visible: true,
      multiline: false,
    },
    'x-component-props-config': {},
  };
};
